import clsx from 'clsx';
import { GatsbyImage } from 'gatsby-plugin-image';
import { twMerge } from 'tailwind-merge';

import { Container, Section } from 'components/GridV2';
import { Minus } from 'components/icons/Minus';
import { Plus } from 'components/icons/Plus';
import { Accordion } from 'components/rebrand/Accordion';
import CustomPortableText from 'components/rebrand/CustomPortableText';

import { ISanityGeneralFeatures } from 'typescriptDefs';

interface Props {
  features: ISanityGeneralFeatures[];
}

const Features = ({ features }: Props) => {
  return (
    <>
      {features.map((feature, index) => (
        <IndividualFeature feature={feature} index={index} key={feature.buttonText || index} />
      ))}
    </>
  );
};

export default Features;

const IndividualFeature = ({ feature, index }: { feature: ISanityGeneralFeatures; index: number }) => {
  const isEven = index % 2 === 0;

  return (
    <Section className={clsx(isEven ? 'bg-white' : 'bg-primary-50')}>
      <Container className="grid items-center gap-16 px-32 py-64 md:grid-cols-2 md:gap-130 md:px-[unset] md:pb-120 md:pt-80">
        <div className={twMerge(clsx('order-2 overflow-hidden rounded-16', isEven ? 'md:order-2' : 'md:order-1'))}>
          <GatsbyImage alt={feature.image.altText} image={feature.image.img.asset.gatsbyImageData} />
        </div>
        <div className={clsx(!isEven && 'order-1 md:order-2')}>
          <div className="mb-16 [&_h2]:uppercase [&_h2]:text-primary-400 [&_h2_strong]:text-primary-200">
            <CustomPortableText content={feature.heading} />
          </div>
          <div className="mb-32 grid gap-16">
            <CustomPortableText content={feature.content} />
          </div>
          {feature.accordionItems &&
            feature.accordionItems.map((item) => (
              <Accordion
                className="border-t border-grey-100 py-24 md:py-32"
                title={<h3 className="text-md font-bold text-grey-500 md:text-xl">{item.heading}</h3>}
                key={item.heading}
                iconOverrides={{ maximizeIcon: <Plus />, minimizeIcon: <Minus /> }}
              >
                <div className="[&_ol]:pl-0 [&_p]:text-md [&_p]:font-normal [&_p]:leading-normal [&_p]:md:text-lg">
                  <CustomPortableText content={item.content} />
                </div>
              </Accordion>
            ))}
        </div>
      </Container>
    </Section>
  );
};
